import { Component, OnInit } from '@angular/core';
import { EnvService } from '@forgerock/backstage-ui-core';
import { Observable } from 'rxjs';
import { DashboardEnv } from '../model/dashboard-env';
import { UserAccountService } from '../user-account.service';

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss'],
    standalone: false
})
export class DashboardComponent implements OnInit {
  readonly isEmailUnverified$: Observable<boolean>;
  readonly emailVerifiedUntil$: Observable<Date | null>;
  maintenanceMode = false;

  constructor(private readonly userAccountService: UserAccountService,
              private readonly envService: EnvService<DashboardEnv>) {
    this.isEmailUnverified$ = this.userAccountService.isEmailUnverified();
    this.emailVerifiedUntil$ = this.userAccountService.getEmailVerifiedUntil();
  }

  async ngOnInit(): Promise<void> {
    try {
      this.maintenanceMode = !!(await this.envService.get()).maintenanceMode;
    } catch {
      this.maintenanceMode = false;
    }
  }
}
